import {FC, ReactNode} from "react";
import {Box} from "@mui/material";

interface TabPanelProps {
    children?: ReactNode;
    index: number;
    value: number;
}

const TabPanel:FC<TabPanelProps>  = (props ) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tab-panel"
            hidden={value !== index}
            id={`tab-panel-${index}`}
            aria-labelledby={`tab-${index}`}
            className={`panel-body`}
            {...other}
        >
            {value === index && (
                <>
                    {children}
                </>
            )}
        </div>
    );
}

export default TabPanel;